export default [
  {
    path: '',
    name: 'home',
    component: () => import('@/views/Home.vue'),
    meta: {
      pageTitle: 'Statistics',
      breadcrumb: [
        {
          text: 'Statistics',
          active: true,
        },
      ],
      resource: 'Home',
    },
  },
]
